import { initSliders } from 'components/swiper-init/index';

import './index.scss';

const singleProductPage = () => {
	document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll(".quantity").forEach(function (wrapper) {
            let input = wrapper.querySelector("input[type=number]");
            wrapper.querySelector(".custom-qty-plus")?.addEventListener("click", () => input.stepUp());
            wrapper.querySelector(".custom-qty-minus")?.addEventListener("click", () => input.stepDown());
        });
    });

    document.addEventListener("DOMContentLoaded", function () {
	    const priceEl = document.querySelector('.summary .price');
	    if (!priceEl) return;

	    const originalPrice = priceEl.innerHTML;

	    if (typeof jQuery !== "undefined") {
	        jQuery('.variations_form')
	            .on('found_variation', function (event, variation) {
	                if (variation && variation.price_html) {
	                    priceEl.innerHTML = variation.price_html;
	                }
	            })
	            .on('reset_data', function () {
	                priceEl.innerHTML = originalPrice;
	            });
	    }
	});

	initSliders('.related.products .slider-content .swiper');
};

export default singleProductPage;
